<template>
  <div
    :style="{
      marginTop: info.rules.length ? 0 : '10px'
    }"
  >
    <div
      class="award-lists"
      :style="{
        paddingBottom: showBottomPd ? '15px' : 0,
        paddingTop: info.rules.length ? 0 : '15px'
      }"
    >
      <div class="award-item" v-for="(item, index) in info.awards" :key="index">
        <img
          class="a-icon"
          @click.stop="previewImage(item.imgs)"
          :src="item.imgs[0] || default_banner"
          mode="aspectFill"
        />
        <div class="a-r">
          <div class="a-title">
            <label class="a-name">{{
              info.awards.length == 1 ? "奖品" : prize_order[index] + "等奖"
            }}</label
            >{{ item.title }}
          </div>
          <div class="a-desc">
            <label class="desc-item">数量: {{ item.count }}份</label>
            <label class="desc-item" v-if="info.temp != 3"
              >满{{ item.min_score }}分</label
            >
            <label
              class="desc-item"
              v-if="info.award_run_way == 1 && info.show_award_prob"
              >中奖率{{ accMul(item.award_prob, 100) }}%</label
            >
          </div>
        </div>
      </div>
      <div class="run-time" v-if="info.award_run_way == 0">
        {{ info.awardRuntime }}
        {{ info.award_run_status == 2 ? "已开奖" : "到时自动开奖" }}
      </div>
    </div>
    <div class="awards-box" v-if="info.my_awards.length">
      <div class="awards-content">
        <img
          class="top-cover"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-22/8c71c25048cb660174442f1b846c50cc.png"
          mode="aspectFill"
        />
        <!-- <div class="a-tips">
          领奖时间截止开奖后7天内，超时间将失效，请及时领取
        </div> -->
        <div
          class="al-item"
          v-for="(item, index) in info.my_awards"
          :key="index"
        >
          <div class="al-l">
            <div>
              {{
                info.awards.length == 1
                  ? "奖品"
                  : prize_order[item.idx] + "等奖"
              }}：{{ item.title }}
            </div>
            <div class="a-time">{{ item.t_submit }}</div>
          </div>
          <div
            class="al-r"
            @click.stop="toAddress('', index)"
            v-if="item.deliver_way == 1 && !item.logistics"
          >
            立即领取
          </div>
          <div
            class="al-r"
            @click.stop="toCash(item.rid, index)"
            v-else-if="item.status == 0"
          >
            立即领取
          </div>
          <div
            class="al-r"
            @click.stop="toAddress(item.logistics, index)"
            v-else-if="item.status == 1"
          >
            等待发货
          </div>
          <div
            class="al-r"
            @click.stop="toAddress(item.logistics, index)"
            v-else-if="item.status == 3"
          >
            已发货
          </div>
          <div
            class="al-r"
            @click.stop="toCash(item.rid)"
            v-else-if="item.status == 2"
          >
            已兑奖
          </div>
        </div>
      </div>
      <div class="w-award-list" v-if="info.has_contact">
        <div v-if="info.show_award_lists" @click.stop="awardsList()">
          查看中奖名单
        </div>
        <div
          :class="
            info.show_award_lists ? 'more-contact active' : 'more-contact'
          "
          @click.stop="call()"
        >
          更多联系方式
        </div>
      </div>
      <div
        class="w-award-list"
        @click.stop="awardsList()"
        v-if="info.show_award_lists && !info.has_contact"
      >
        查看中奖名单>>
      </div>
    </div>
    <div
      class="winning-box"
      v-else-if="info.has_joined == 0 && info.award_run_status == 2"
    >
      <div class="w-title title-black">抽奖已结束</div>
      <div class="lose-btn" @click.stop="toHome()">
        参与其他答题
      </div>
      <div
        class="w-award-list"
        v-if="info.show_award_lists"
        @click.stop="awardsList()"
      >
        查看中奖名单>>
      </div>
    </div>
    <div
      class="winning-box"
      v-else-if="
        info.has_joined &&
          (info.award_run_status > 1 ||
            !(info.award_run_status == 1 && info.award_run_way == 0)) &&
          info.my_awards.length == 0 &&
          !(!info.use_draws_count && info.award_run_way == 1)
      "
    >
      <div class="w-title title-black">未中奖，谢谢参与</div>
      <div class="lose-btn" @click.stop="toHome()">
        参与其他答题
      </div>
      <div
        class="w-award-list"
        v-if="info.show_award_lists"
        @click.stop="awardsList()"
      >
        查看中奖名单>>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, ImagePreview, Dialog } from "vant";
import { accMul } from "../../utils/common";
export default {
  props: ["info", "isMobile", "isWeixin"],
  data() {
    return {
      accMul: accMul,
      showBottomPd: false,
      prize_order: "一二三四五六七八九十",
      default_banner:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-22/2dcd64e204f1a0e55712daa41ea76dd9.png"
    };
  },
  mounted() {
    this.getPadding();
  },
  methods: {
    call() {
      if (wemeet.app.isTMWebview() || this.info.enterprise_vip) {
        Dialog.confirm({
          title: "",
          message: this.info.award_contact,
          cancelButtonText: "我知道了",
          confirmButtonColor: "#1890ff",
          cancelButtonColor: "#999999",
          confirmButtonText: "复制"
        })
          .then(() => {
            this.$copyText(this.info.award_contact);
            Toast("复制成功");
          })
          .catch(() => {});
      } else {
        this.$emit("handleVipTip");
      }
    },
    toAddress(logistics, index) {
      let { my_awards, awards } = this.info;
      let name = my_awards[index].title;
      let idx = my_awards[index].idx;
      let title = `${
        awards && awards.length > 1 ? this.prize_order[idx] + "等奖" : "奖品"
      }：${name}`;
      if (!logistics) {
        logistics = {};
      }
      localStorage.setItem(
        "logistics",
        JSON.stringify({
          ...logistics,
          title,
          qid: this.info.qid
        })
      );
      if (wemeet.app.isTMWebview() || this.info.enterprise_vip) {
        this.$router.push({ name: "awardsAddress" });
      } else {
        this.$emit("handleVipTip");
      }
    },
    toCash(rid) {
      if (wemeet.app.isTMWebview() || this.info.enterprise_vip) {
        this.$router.push({ name: "awardsCash", query: { rid: rid } });
      } else {
        this.$emit("handleVipTip");
      }
    },
    getPadding() {
      let { info } = this;
      let case1 = info.my_awards.length;
      let case2 = info.has_joined == 0 && info.award_run_status == 2;
      let case3 =
        info.has_joined &&
        (info.award_run_status > 1 ||
          !(info.award_run_status == 1 && info.award_run_way == 0)) &&
        info.my_awards.length == 0 &&
        !(!info.use_draws_count && info.award_run_way == 1);
      let case4 = info.awards && info.awards.length && info.my_awards.length == 0;

      if (case1 || case2 || case3 || case4) {
        this.showBottomPd = true;
      } else {
        if (info.enterprise_vip || !info.owner_vip) {
          this.showBottomPd = true;
        }
      }
    },
    previewImage(item) {
      let target = item.length ? item : [this.default_banner];
      ImagePreview({
        images: target,
        startPosition: 0
      });
    },
    copySuccess() {
      Toast("复制成功");
    },
    awardsList(tab) {
      if (
        wemeet.app.isTMWebview() ||
        (this.info.enterprise_vip && this.info.unionid)
      ) {
        this.$router.push({
          name: "awardsList",
          query: { qid: this.info.qid, tab }
        });
      } else {
        if (!this.isWeixin && this.isMobile && !this.info.unionid) {
          this.$emit("getLoginCode", true);
          return;
        }
        if (!this.isWeixin && !this.isMobile && !this.info.unionid) {
          this.$emit("getLoginCode");
          return;
        }
        if (!this.info.enterprise_vip) {
          this.$emit("handleVipTip");
          return;
        }
        this.$router.push({
          name: "awardsList",
          query: { qid: this.info.qid, tab }
        });
      }
    },
    toHome() {
      if (
        wemeet.app.isTMWebview() ||
        (this.info.enterprise_vip && this.info.unionid)
      ) {
        this.$router.push({ name: "home" });
      } else {
        if (!this.isWeixin && this.isMobile && !this.info.unionid) {
          this.$emit("getLoginCode", true);
          return;
        }
        if (!this.isWeixin && !this.isMobile && !this.info.unionid) {
          this.$emit("getLoginCode");
          return;
        }
        if (!this.info.enterprise_vip) {
          this.$emit("handleVipTip");
          return;
        }
        this.$router.push({ name: "home" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.award-lists {
  background: #ffffff;
  padding: 0 15px;
}
.award-item {
  display: flex;
  background: #f3f3f3;
  padding: 10px;
  margin-top: 15px;
  border-radius: 4px;
  font-size: 14px;
}
.award-item:first-child {
  margin-top: 0;
}
.a-r {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
}
.a-name {
  font-size: 12px;
  color: #a8071a;
  border: 1px solid #a8071a;
  border-radius: 2px;
  height: 19px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-right: 7.5px;
}
.a-desc {
  font-size: 12px;
  color: #999999;
}
.desc-item {
  margin-right: 5px;
}
.a-icon {
  width: 75px;
  height: 75px;
  min-width: 75px;
  margin-right: 8px;
  border-radius: 4px;
  object-fit: cover;
}
.awards-box {
  background: #ffffff;
  padding: 15px;
  margin-top: 10px;
}
.awards-content {
  border: 7.5px solid #a8071a;
  border-radius: 10px;
  padding: 37px 10px 10px;
  position: relative;
}
.top-cover {
  position: absolute;
  top: -12.5px;
  width: 167.5px;
  height: 35.5px;
  left: 50%;
  transform: translateX(-50%);
}
.a-tips {
  background: #fef0ef;
  padding: 9px 15px;
  font-size: 12px;
  margin: 27.5px 0 15px;
  border-radius: 8px;
}
.al-item {
  margin-bottom: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.al-item:last-child {
  margin-bottom: 0;
}
.al-item-l {
  flex: 1;
}
.a-time {
  font-size: 13px;
  color: #999999;
  margin-top: 2.5px;
  line-height: 19px;
}
.al-r {
  border: 1px solid #a8071a;
  padding: 7.5px;
  font-size: 12px;
  color: #a8071a;
  background: #ffffff;
  border-radius: 4px;
  flex-shrink: 0;
  cursor: pointer;
}
.w-award-list {
  display: flex;
  align-items: center;
  justify-content: center;
  /* text-decoration: underline; */
  font-size: 13px;
  color: #999;
  margin-top: 15px;
}
/* winning-box */
.winning-box {
  margin-top: 10px;
  background: #fff;
  padding-bottom: 15px;
  text-align: center;
}

.w-title {
  font-size: 16px;
  text-align: center;
  padding-top: 15px;
}

.title-black {
  color: #262626;
}

.w-desc {
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  max-width: 345px;
  overflow: hidden;
  word-break: break-all;
  margin: 0 15px;
}

.w-desc .w-item {
  display: block;
}
.lose-btn {
  display: inline-block;
  margin: 10px auto 0;
  padding: 2.5px 15px;
  background: #a8071a;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
}
.run-time {
  font-size: 13px;
  padding-top: 15px;
}

.more-contact {
  position: relative;
  padding-left: 6px;
  margin-left: 5px;
}

.more-contact.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  border-left: 1px solid #999999;
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/awards.vue